import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';

import { FinancieroAlertaRoutingModule } from './financiero-alerta-routing.module';
import { CatalogoCuentasComponent } from './catalogo-cuentas/catalogo-cuentas.component';
import { EstadosFinancierosComponent } from './estados-financieros/estados-financieros.component';
import { IndicadoresFinancierosComponent } from './indicadores-financieros/indicadores-financieros.component';
import { IndicadoresPerlasComponent } from './indicadores-perlas/indicadores-perlas.component';
import { IndicadoresProductividadComponent } from './indicadores-productividad/indicadores-productividad.component';
import { IndicadoresCoberturaComponent } from './indicadores-cobertura/indicadores-cobertura.component';
import { CoberturaComponent } from './cobertura/cobertura.component';
import { ActivosPonderadosComponent } from './activos-ponderados/activos-ponderados.component';
import { PlanesComponent } from './planes/planes.component';
import { SeguimientoPlanesComponent } from './seguimiento-planes/seguimiento-planes.component';
import { ReporteFinancieroComponent } from './reporte-financiero/reporte-financiero.component';


@NgModule({
  declarations: [
    CatalogoCuentasComponent,
    EstadosFinancierosComponent,
    IndicadoresFinancierosComponent,
    IndicadoresPerlasComponent,
    IndicadoresProductividadComponent,
    IndicadoresCoberturaComponent,
    CoberturaComponent,
    ActivosPonderadosComponent,
    PlanesComponent,
    SeguimientoPlanesComponent,
    ReporteFinancieroComponent,
  ],
  imports: [
    CommonModule,
    FinancieroAlertaRoutingModule,
    SharedModule
  ]
})
export class FinancieroAlertaModule { }
